export default "__VITE_ASSET__DA5ewCPN__"